import Stripe from "stripe";

import * as Sentry from "@sentry/react";

import { stripe } from "../../api";

const useShipping = () => {
  const fetchShippingPrices = async (
    shippingRatesIds: string[]
  ): Promise<Stripe.ShippingRate[]> => {
    let shippingPrices: Stripe.ShippingRate[] = [];
    try {
      const { data } = await stripe.stripePost("shipping-rates", {
        shippingRatesIds,
      });
      shippingPrices = data;
    } catch (err) {
      Sentry.captureException(err);
    } finally {
      return shippingPrices;
    }
  };

  return { fetchShippingPrices };
};

export default useShipping;
